import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/transitional/components/Select';
import getDefaultMeetingsLink from './getDefaultMeetingsLink';
import { MEETINGS_LINK_TYPES as LINK_TYPES, SENDER_MEETINGS_LINK_TOKEN } from 'hubspot-prosemirror/draft-transplant/utils/constants';
import { getMeetingsUrl } from 'hubspot-prosemirror/draft-transplant/utils/links';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import { useCallback } from 'react';
import MeetingsLinkSelectionRadio from './MeetingsLinkSelectionRadio';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const MEETING_RADIO_NAME = 'meetings-link-selection';
const MeetingsLinkSelection = ({
  meetingsLinks,
  linkURL,
  meetingsLinkOptions,
  text,
  linkName,
  linkType,
  allowSenderMeetingLink,
  setText,
  setLinkURL,
  setLinkName,
  setLinkType
}) => {
  const defaultMeeting = getDefaultMeetingsLink(meetingsLinks);
  const selectValue = linkURL && linkURL !== SENDER_MEETINGS_LINK_TOKEN ? linkURL : defaultMeeting.link;
  const handleMeetingLinkSelection = useCallback(({
    target: {
      value
    }
  }) => {
    const name = value.text;
    const url = value.value;
    const replaceText = (text === '' || text === linkName) && linkType === LINK_TYPES.CUSTOM;
    const updatedText = replaceText ? name : text;
    setText(updatedText);
    setLinkURL(url);
    setLinkName(name);
  }, [linkName, linkType, setLinkName, setLinkURL, setText, text]);
  const handleRadioChange = useCallback(selectedLinkType => {
    const updatedText = text === linkURL ? '' : text;
    setLinkType(selectedLinkType);
    setText(updatedText);
  }, [linkURL, setLinkType, setText, text]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.meetings.linkTo"
      }),
      marginBlockEnd: "300",
      children: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(MeetingsLinkSelectionRadio, {
          linkType: linkType,
          radioName: MEETING_RADIO_NAME,
          selectedLink: selectValue,
          handleRadioChange: handleRadioChange,
          allowSenderMeetingLink: allowSenderMeetingLink
        }), /*#__PURE__*/_jsx(Select, {
          "data-test-id": "meetings-select",
          dropdownFooter: /*#__PURE__*/_jsx(Button, {
            href: getMeetingsUrl(),
            external: true,
            use: "link",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "hubspot-prosemirror.meetings.manageLinks"
            })
          }),
          onSelectedOptionChange: handleMeetingLinkSelection,
          options: meetingsLinkOptions,
          value: selectValue
        })]
      })
    }), allowSenderMeetingLink && /*#__PURE__*/_jsx(RadioInput, {
      name: MEETING_RADIO_NAME,
      checked: linkType === LINK_TYPES.SENDER,
      onChange: () => handleRadioChange(LINK_TYPES.SENDER),
      padding: "0",
      "data-test-id": "senders-meeting-token-radio",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.meetings.sendermeetingslink"
      })
    })]
  });
};
export default MeetingsLinkSelection;